<template>
    <v-row class="ma-n8">
        <v-col class="pa-8" cols="12">
            <v-text-field v-model="form.term" v-bind="attrs_input" label="필드명" @input="emit" />
        </v-col>
        <template v-if="form.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value">
            <v-col class="pa-8" cols="12">
                <v-switch v-model="form.data" v-bind="attrs_switch" label="필드값" @change="emit" class="mx-8 my-2" />
            </v-col>
        </template>
        <template v-else>
            <v-col class="pa-8" cols="12">
                <v-switch v-model="form.isRequired" v-bind="attrs_switch" label="필수여부" @change="emit" class="mx-8 my-2" />
            </v-col>
        </template>
    </v-row>
</template>

<script>
import { attrs_input, attrs_switch, EMPLOYMENT_FIELD_SIDES, initEmploymentField } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initEmploymentField },
    },
    data: () => ({
        form: initEmploymentField(),

        EMPLOYMENT_FIELD_SIDES,
        attrs_input,
        attrs_switch,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
